import type { AnyRoute } from "@tanstack/react-router";

import { createAlertsListRoutes } from "./createAlertsListRoutes";
import type { AlertsRouteDeps } from "./alertsRouteContext";

export type { AlertsRouteDeps, AlertsRouteFactory } from "./alertsRouteContext";

export function createAlertsRoutes(deps: AlertsRouteDeps): AnyRoute[] {
  return [...createAlertsListRoutes(deps)];
}
